module.exports = __webpack_public_path__ + "static/zero-corruption-16c36d349329e576bb5b9bbf70716a8a.jpg";